import { render, staticRenderFns } from "./TraceabilitySearchBatch.vue?vue&type=template&id=004b8ad2&scoped=true"
import script from "./TraceabilitySearchBatch.vue?vue&type=script&lang=js"
export * from "./TraceabilitySearchBatch.vue?vue&type=script&lang=js"
import style0 from "./TraceabilitySearchBatch.vue?vue&type=style&index=0&id=004b8ad2&prod&lang=scss&scoped=true"
import style1 from "./TraceabilitySearchBatch.vue?vue&type=style&index=1&id=004b8ad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b8ad2",
  null
  
)

export default component.exports